import type { IconData } from '@stacksjs/iconify-core'

export const layoutF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9 20V8h9v9a3 3 0 0 1-3 3zm-2 0H3a3 3 0 0 1-3-3V8h7zM18 6H0V3a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default layoutF
